import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Gauge } from "lucide-react";
import { api } from "../../lib/api";

export default function Tracking() {
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const load = () => api.get("/tracking").then((r) => setList(r.data));
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, []);

  // map lat/lng to % position (around Rome center)
  const project = (lat, lng) => {
    const baseLat = 41.9028, baseLng = 12.4964;
    const x = 50 + (lng - baseLng) * 600;
    const y = 50 - (lat - baseLat) * 600;
    return { left: `${Math.max(2, Math.min(98, x))}%`, top: `${Math.max(2, Math.min(98, y))}%` };
  };

  return (
    <div className="space-y-6" data-testid="tracking-page">
      <div>
        <h1 className="font-display text-3xl font-black uppercase tracking-tight">Tracking GPS</h1>
        <p className="text-sm text-white/45 mt-1">{list.length} veicoli mappati in tempo reale · aggiornamento ogni 8s</p>
      </div>

      <div className="grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 glass rounded-2xl overflow-hidden">
          <div className="aspect-[4/3] relative bg-[#080809]" data-testid="tracking-map">
            <div className="absolute inset-0 grid-bg" />
            {/* Concentric rings */}
            <div className="absolute inset-0 grid place-items-center pointer-events-none">
              {[120, 220, 320, 420].map((s) => (
                <div key={s} className="absolute rounded-full border border-[#ff0033]/10" style={{ width: s, height: s }} />
              ))}
            </div>
            {list.map((p, i) => {
              const pos = project(p.lat, p.lng);
              const active = selected?.car?.id === p.car.id;
              return (
                <button key={i} onClick={() => setSelected(p)} style={pos}
                  className="absolute -translate-x-1/2 -translate-y-1/2 group"
                  data-testid={`map-pin-${p.car.targa}`}>
                  <div className={`w-3 h-3 rounded-full bg-[#ff0033] ${active ? "pulse-neon scale-150" : "pulse-neon"}`} />
                  <div className="absolute left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap text-[10px] font-mono bg-black/70 px-2 py-0.5 rounded border border-white/10 opacity-0 group-hover:opacity-100 transition">
                    {p.car.marca} {p.car.modello}
                  </div>
                </button>
              );
            })}
            <div className="absolute top-4 left-4 px-3 py-1.5 glass text-[10px] uppercase tracking-widest text-white/60 rounded-full flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#ff0033] pulse-neon" /> Live · Roma
            </div>
          </div>
        </div>

        <div className="glass rounded-2xl p-5 max-h-[600px] overflow-auto" data-testid="tracking-list">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">Veicoli</div>
          <div className="space-y-2">
            {list.map((p) => (
              <motion.button key={p.car.id} onClick={() => setSelected(p)}
                whileHover={{ x: 4 }}
                className={`w-full text-left p-3 rounded-xl border transition ${selected?.car?.id === p.car.id ? "bg-[#ff0033]/10 border-[#ff0033]/40" : "bg-white/[0.02] border-white/5 hover:border-white/20"}`}>
                <div className="flex items-center justify-between">
                  <div className="min-w-0">
                    <div className="font-medium text-sm truncate">{p.car.marca} {p.car.modello}</div>
                    <div className="text-[10px] font-mono text-white/40">{p.car.targa}</div>
                  </div>
                  <div className="flex items-center gap-1 text-[#ff0033] text-xs font-mono">
                    <Gauge size={12} />{p.velocita} km/h
                  </div>
                </div>
                <div className="mt-2 flex items-center gap-1 text-[10px] text-white/40 font-mono">
                  <MapPin size={10} />{p.lat.toFixed(4)}, {p.lng.toFixed(4)}
                </div>
              </motion.button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
